import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as emailjs from 'emailjs-com';
import { withRouter } from 'react-router-dom';
import LazyLoad from 'react-lazyload';
import SvgCircle from '../components/svgCircle';

const Contact = ({ history }) => {

   const { t } = useTranslation()
   const [phoneNumber, setPhoneNumber] = useState('')
   const [email, setEmail] = useState('')
   const [message, setMessage] = useState('')
   const [name, setName] = useState('')

   const changePhone = (e) => {

      // allow + - sign in beginning and only digits.
      const regx = /[^\d+]|(?!^)\+/g
      const lc = e.target.value.replace(regx, '')

      lc.length > 16 ? setPhoneNumber(phoneNumber) : setPhoneNumber(lc)
   }

   const changeName = (e) => {
      setName(e.target.value)
   }

   const changeEmail = (e) => {
      setEmail(e.target.value)
   }

   const changeMessage = (e) => {
      setMessage(e.target.value)
   }

   const handleSubmit = (e) => {
      e.preventDefault()

      const template_params = {
         sender_email: email,
         sender_name: name,
         phone_number: phoneNumber,
         message_html: message,
      }

      const service_id = "default_service";
      const template_id = "contact_form";
      const user_id = 'user_ePy48gUQXRbR2h4Ql8DHS';

      emailjs.send(service_id, template_id, template_params, user_id)
         .then(function (response) {
            console.log('SUCCESS!', response.status, response.text);
            history.push({
               pathname: '/thank-you'
            });
         }, function (error) {
            console.log('FAILED...', error);
         });

   }

   return (
      <section id="contact" className="contact">
         <div className="contact-decor">
            <div className="contact-circle1 circle-shadow">
               <SvgCircle color1="#15F6D5" color2="#17D1DF" r1="40" r2="10" />
            </div>
            <div className="contact-circle2 circle-shadow">
               <SvgCircle color1="#15F6D5" color2="#17D1DF" r1="75" r2="47" />
            </div>
         </div>
         <div className="container">
            <div className="row">
               <div className="col-md-12 col-lg-8 col-sm-12">
                  <div className="contact-us">
                     <div className="w-100">
                        <h2 className="title pink-title text-center text-md-left"><span>{t('contact')} </span>{t('information')}</h2>
                        <form className="theme-form" onSubmit={(e) => handleSubmit(e)}>
                           <div className="form-group">
                              <div className="row">
                                 <div className="col-sm-12 col-md-6 md-fgrup-margin">
                                    <input type="text" className="form-control" value={name} onChange={changeName} placeholder={t('your name')} required="required" />
                                 </div>
                                 <div className="col-sm-12 col-md-6">
                                    <input type="text" className="form-control" value={phoneNumber} onChange={changePhone} placeholder={t('phone')} required="required" />
                                 </div>
                              </div>
                           </div>
                           <div className="form-group">
                              <input type="email" className="form-control" value={email} onChange={changeEmail} id="exampleFormControlInput1" placeholder={t('email address')} required="required" />
                           </div>
                           <div className="form-group">
                              <textarea className="form-control" value={message} onChange={changeMessage} id="exampleFormControlTextarea1" rows="4" placeholder={t('message')} required="required"></textarea>
                           </div>
                           <div className="form-button text-center text-md-right">
                              <button type="submit" className="btn btn-custom theme-color">{t('send')}</button>
                           </div>
                        </form>
                     </div>
                  </div>
               </div>
               <div className="col-lg-4 d-medium-none-lg">
                  <div className="contact-right">
                     <LazyLoad><img src="assets/images/Contact-bubble.png" className="img-fluid contact-bubble" alt="contact-icon" /></LazyLoad>
                  </div>
               </div>
            </div>
         </div>
      </section>
   );
}

export default withRouter(Contact);


// WEBPACK FOOTER //
// ./src/components/contact.js